<div class="meeting-create-container">
  <div class="create-header">
    <button
      type="button"
      class="btn btn-outline-secondary back-button"
      (click)="goBackToList()"
    >
      <i class="fa fa-arrow-left" aria-hidden="true"></i>
      <span translate>BACK</span>
    </button>
    <h3 translate>CREATE_APPRAISAL_MEETING</h3>
  </div>

  <div class="create-card">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">

      <div class="form-group" [class.has-error]="form.get('TemplateId')?.invalid && form.get('TemplateId')?.touched">
        <label class="control-label">{{ 'FORM' | translate }} <span class="required">*</span></label>
        <p-select
          [options]="templates"
          formControlName="TemplateId"
          optionLabel="label"
          optionValue="value"
          placeholder="{{ 'SELECT_TEMPLATE' | translate }}"
          [style]="{'width': '100%'}"
          appendTo="body">
        </p-select>
        <span class="help-block" *ngIf="form.get('TemplateId')?.hasError('required') && form.get('TemplateId')?.touched">
          {{ 'TEMPLATE_REQUIRED' | translate }}
        </span>
      </div>

      <div class="form-group" [class.has-error]="form.get('EmployeeUserId')?.invalid && form.get('EmployeeUserId')?.touched">
        <label class="control-label">{{ 'EMPLOYEE' | translate }} <span class="required">*</span></label>
        <p-select
          [options]="employees"
          formControlName="EmployeeUserId"
          optionLabel="label"
          optionValue="value"
          [placeholder]="employeePlaceholder"
          [filter]="true"
          filterBy="label"
          [disabled]="!form.get('TemplateId')?.value || isLoadingEmployees"
          [style]="{'width': '100%'}"
          panelStyleClass="appraisal-employee-dropdown-panel"
          appendTo="body">
          <ng-template let-employee pTemplate="selectedItem">
            <div class="employee-option employee-option-selected" *ngIf="employee">
              <span class="employee-option-name">{{ employee.label }}</span>
              <span
                class="employee-status-pill"
                [ngClass]="getEmployeeStatusClass(employee)"
                [attr.title]="getEmployeeStatusHelpKey(employee) | translate"
              >
                <i
                  class="fa"
                  [ngClass]="getEmployeeStatusIcon(employee)"
                  aria-hidden="true"
                ></i>
                {{ getEmployeeStatusLabelKey(employee) | translate }}
              </span>
            </div>
          </ng-template>
          <ng-template let-employee pTemplate="item">
            <div
              class="employee-option employee-option-row"
              [ngClass]="getEmployeeStatusClass(employee)"
            >
              <div class="employee-option-main">
                <span class="employee-option-name">{{ employee.label }}</span>
                <span
                  class="employee-status-pill"
                  [ngClass]="getEmployeeStatusClass(employee)"
                >
                  <i
                    class="fa"
                    [ngClass]="getEmployeeStatusIcon(employee)"
                    aria-hidden="true"
                  ></i>
                  {{ getEmployeeStatusLabelKey(employee) | translate }}
                </span>
              </div>
              <small class="employee-status-help">
                {{ getEmployeeStatusHelpKey(employee) | translate }}
              </small>
            </div>
          </ng-template>
        </p-select>
        <span class="help-block info" *ngIf="form.get('TemplateId')?.value && !isLoadingEmployees && employees.length === 0">
          {{ 'NO_ACTIVE_EMPLOYEES_FOR_APPRAISAL' | translate }}
        </span>
        <span class="help-block" *ngIf="form.get('EmployeeUserId')?.hasError('required') && form.get('EmployeeUserId')?.touched">
          {{ 'EMPLOYEE_REQUIRED' | translate }}
        </span>
      </div>

      <div class="form-group" [class.has-error]="form.get('Title')?.invalid && form.get('Title')?.touched">
        <label class="control-label">{{ 'TITLE' | translate }} <span class="required">*</span></label>
        <input
          type="text"
          class="form-control"
          formControlName="Title"
          maxlength="255" />
        <span class="help-block" *ngIf="form.get('Title')?.hasError('required') && form.get('Title')?.touched">
          {{ 'TITLE_REQUIRED' | translate }}
        </span>
      </div>

      <div class="form-row-inline">
        <div class="form-group" style="flex: 1.4" [class.has-error]="form.get('StartDate')?.invalid && form.get('StartDate')?.touched">
          <label class="control-label">{{ 'START_DATE' | translate }} <span class="required">*</span></label>
          <input
            type="date"
            class="form-control"
            formControlName="StartDate"
            [min]="minStartDate" />
          <span class="help-block" *ngIf="form.get('StartDate')?.hasError('required') && form.get('StartDate')?.touched">
            {{ 'SCHEDULED_DATE_REQUIRED' | translate }}
          </span>
        </div>
        <div class="form-group" style="flex: 1" [class.has-error]="(form.get('StartTime')?.invalid || form.hasError('startTimeInPast')) && (form.get('StartTime')?.touched || form.get('StartDate')?.touched)">
          <label class="control-label">{{ 'START_TIME' | translate }} <span class="required">*</span></label>
          <input
            type="time"
            class="form-control"
            formControlName="StartTime"
            step="900" />
          <span class="help-block" *ngIf="form.hasError('startTimeInPast') && (form.get('StartTime')?.touched || form.get('StartDate')?.touched)">
            {{ 'START_TIME_IN_PAST' | translate }}
          </span>
        </div>
        <div class="form-group" style="flex: 1" [class.has-error]="(form.hasError('endTimeBeforeStart') || form.get('EndTime')?.invalid) && form.get('EndTime')?.touched">
          <label class="control-label">{{ 'END_TIME' | translate }} <span class="required">*</span></label>
          <input
            type="time"
            class="form-control"
            formControlName="EndTime"
            step="900" />
          <span class="help-block" *ngIf="form.hasError('endTimeBeforeStart') && form.get('EndTime')?.touched">
            {{ 'END_TIME_AFTER_START_REQUIRED' | translate }}
          </span>
        </div>
      </div>
      <div class="form-group" *ngIf="durationLabel">
        <small class="text-muted">{{ 'DURATION' | translate }}: {{ durationLabel }}</small>
      </div>

      <div class="form-group">
        <label class="control-label">{{ 'APPRAISAL_MANAGER_PRIVATE_NOTES' | translate }}</label>
        <textarea
          class="form-control"
          formControlName="ManagerPrivateNotes"
          rows="4">
        </textarea>
      </div>

      <div class="form-actions">
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="onCancel()">
          {{ 'CANCEL' | translate }}
        </button>
        <button
          type="submit"
          class="btn btn-success"
          [disabled]="form.invalid || isSubmitting">
          <i *ngIf="isSubmitting" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
          {{ 'SAVE' | translate }}
        </button>
      </div>

    </form>
  </div>
</div>

<p-dialog
  [(visible)]="confirmUnmanagedVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="false"
  [style]="{ width: '460px', maxWidth: '95vw' }"
  styleClass="appraisal-pending-access-dialog"
  [header]="'APPRAISAL_CREATE_PENDING_ACCESS_TITLE' | translate"
  (onHide)="confirmUnmanagedCancel()"
>
  <div class="pending-access-dialog-body">
    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
    <p>{{ confirmUnmanagedMessageKey | translate }}</p>
  </div>
  <ng-template pTemplate="footer">
    <div class="dialog-actions">
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="confirmUnmanagedCancel()"
      >
        {{ 'CANCEL' | translate }}
      </button>
      <button
        type="button"
        class="btn btn-success"
        [disabled]="isSubmitting"
        (click)="confirmUnmanagedAccept()"
      >
        <i *ngIf="isSubmitting" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
        {{ 'APPRAISAL_CREATE_MEETING_AS_DRAFT' | translate }}
      </button>
    </div>
  </ng-template>
</p-dialog>

